module.exports = __webpack_public_path__ + "assets/img/51.19b69b1a.jpg";